import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getMimeTypeFa } from 'ecs-react-components/dist/index.es';
import Header from '../../components/Header/Header';
import { messages } from './DownloadableForms.i18n';

import {
  loadDownloadableForms,
  downloadForm,
} from '../../redux/modules/facility/facility-middleware';


class DownloadableForms extends Component {
  componentDidMount() {
    const {
      dispatch,
      facilityId,
    } = this.props;

    dispatch(loadDownloadableForms(facilityId));
  }

  buildGetPdfViewerLink() {
    const { formatMessage } = this.props.intl;
    const href = formatMessage(messages.page.linkHrefPdfViewer);
    const text = formatMessage(messages.page.getPdfViewer);
    const link = '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + text + '</a>';
    return link;
  }

  downloadHandler = (download) => () => {
    this.props.dispatch(downloadForm(download, window.open('about:blank', '_blank')));
  }

  render() {
    const {
      downloadableForms,
    } = this.props;

    return (
      <div>
        <Header
          headerTitle={ <FormattedMessage { ...messages.page.title } /> }
          headerClassName="mb-3"
        />
         {
              downloadableForms.length ?
              <div>
                <div className="row">
                  <div className="col-12 col-lg-6" data-qa-container="downloadableForms">
                  {
                    downloadableForms.sort((a, b) => a.viewOrder - b.viewOrder).map((download, index) => (
                      <div key={index} className="downloadable-form">
                        <span
                          className={
                            download.url ?
                              'fa fa-external-link' :
                              'fa ' + getMimeTypeFa(download.contentType)
}
                          title={ download.fileType }
                        >
                        </span>
                        {
                          download.url ?
                          <span>
                            <a
                              href={ download.url }
                              title={ download.description }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                            { download.title }
                            </a>
                          </span> :
                          <span>
                            <span>
                              <a
                                onClick={ this.downloadHandler(download) }
                                title={ download.description }
                                tabIndex="0"
                                href="#"
                              >
                              { download.title }
                              </a>
                            </span>&nbsp;
                            <FormattedMessage
                              { ...messages.download.size }
                              values={{ size: (download.fileSize / 1000).toFixed(2) }}
                            />
                          </span>
                        }
                      </div>
                    ))
                  }
                  </div>
                </div>
                <div className="row float-right"
                  dangerouslySetInnerHTML={{ __html: this.buildGetPdfViewerLink() }}
                />
              </div> :
                null
            }
      </div>
    );
  }
}

DownloadableForms.propTypes = ({
  dispatch: PropTypes.func,
  downloadableForms: PropTypes.array,
  facilityId: PropTypes.string,
  intl: PropTypes.object,
});

const mapStateToProps = (state) => ({
  downloadableForms: state.facility.resources.downloadableForms,
  facilityId: state.facility.facilityId,
});

export default connect(mapStateToProps)(injectIntl(DownloadableForms));